export default __webpack_public_path__ + "static/media/logo-white.0344bf36.png";